const TileWishListMiddleware = ({ Tile, ...props }) => <Tile {...props} />

export default TileWishListMiddleware
